module.exports = __webpack_public_path__ + "static/hero-what-we-focus-on-ed701e86090ead61a09eea53f2e90efe.png";